import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function ValidIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-valid-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.32 9.96C39.1 13.03 40 16.37 40 20c0 3.63-.9 6.98-2.68 10.04a20.009 20.009 0 01-7.28 7.28C26.97 39.1 23.63 40 20 40c-3.63 0-6.97-.9-10.04-2.68s-5.49-4.21-7.28-7.28S0 23.63 0 20c0-3.63.89-6.97 2.68-10.04S6.9 4.47 9.96 2.68 16.37 0 20 0c3.63 0 6.98.89 10.04 2.68 3.06 1.79 5.49 4.22 7.28 7.28zm-3.88 5.82c0-.49-.16-.88-.47-1.2l-2.37-2.34c-.33-.33-.72-.5-1.17-.5-.45 0-.84.17-1.17.5l-10.63 10.6-5.88-5.89c-.33-.33-.72-.49-1.17-.49-.45 0-.84.16-1.17.49L7.03 19.3c-.31.31-.47.71-.47 1.2 0 .47.16.86.47 1.17l9.43 9.42c.33.33.72.5 1.17.5.47 0 .87-.17 1.2-.5l14.14-14.14c.31-.31.47-.7.47-1.17z"
  })));
}